module.exports = __webpack_public_path__ + "img/DSC_0016.97926675.jpg";